import Seo, { SITE_URL } from "@/components/Seo";
import PageLayout from "@/components/layout/PageLayout";
import Hero from "@/pages/home/components/Hero";
import HotList from "@/pages/home/components/HotList";
import EventShowcase from "@/pages/home/components/EventShowcase";
import Categories from "@/pages/home/components/Categories";
import MethodBand from "@/pages/home/components/MethodBand";
import Testimonials from "@/pages/home/components/Testimonials";
import Principles from "@/pages/home/components/Principles";
import FaqCta from "@/pages/home/components/FaqCta";

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "吃瓜路线",
      url: SITE_URL,
      description: "线索串联、事件地图与理性吃瓜的信息整理平台。",
      email: "hello@chigualuxian.example",
    },
    {
      "@type": "WebSite",
      name: "吃瓜路线",
      url: SITE_URL,
      description: "把零散吃瓜线索串成完整事件地图，从时间线到关键人物，从各方观点到网友评论一目了然。",
    },
    {
      "@type": "WebPage",
      name: "吃瓜路线 - 首页",
      url: SITE_URL + "/",
      description: "吃瓜路线首页：热榜热点坐标、事件地图专区、瓜田栏目与理性吃瓜方法论。",
      isPartOf: { "@type": "WebSite", name: "吃瓜路线", url: SITE_URL },
    },
  ],
};

export default function Home() {
  return (
    <PageLayout>
      <Seo
        title="吃瓜路线 - 线索串联，复杂事件轻松理清"
        description="吃瓜路线帮你把零散的吃瓜线索串联成完整的事件地图：从时间线到关键人物，从各方观点到网友评论一目了然。理性吃瓜、信息溯源，再复杂的瓜也能轻松吃透，不再云里雾里。"
        keywords="吃瓜路线,吃瓜路线事件地图,吃瓜路线瓜田分布,吃瓜路线热点坐标,吃瓜路线话题导览,吃瓜路线线索串联"
        path="/"
        schema={homeSchema}
      />
      <Hero />
      <HotList />
      <EventShowcase />
      <Categories />
      <MethodBand />
      <Testimonials />
      <Principles />
      <FaqCta />
    </PageLayout>
  );
}